import React from "react";
import "./Baskan.css"; // CSS dosyasını import ediyoruz
import { FaFacebookF, FaInstagram, FaXTwitter } from "react-icons/fa6";

export default function Baskan() {
  return (
    <div className="baskan-container-main">
      <a href="/belediye-baskani" className="baskan-foto-link">
        <img
          src="/images/BaskanOsmanCelik.webp"
          alt="Belediye Başkanı Osman Çelik"
          width="600"
          height="600"
          loading="lazy"
          className="baskan-sol-foto"
        />
      </a>
      <div className="baskan-social-box">
        <a href="/belediye-baskani" className="baskan-isim-kutu">OSMAN ÇELİK</a>
        <p className="baskan-unvan-kutu">Serdivan Belediye Başkanı</p>
        <div className="baskan-social-icons">
          <a href="https://www.facebook.com/OsmanSRD/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/osmanceliksrd/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://x.com/osmancelikSRD" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
            <FaXTwitter />
          </a>
        </div>
      </div>
    </div>
  );
}
